<template>
  <div class="pt-2 description">{{content}}</div>

</template>

<script>
export default {
  name: 'MsgNotification',
  components: {},
  created() {
  },
  props: ['content'],
  data() {
    return {}
  },

  methods: {}

};
</script>

<style lang="scss" scoped>
.description {
  text-align: center;
  word-wrap: break-word;
  font-size: 14px;
}
</style>